<h1 class="page-header">Contact us</h1>

<section class="contact-info">
  <div class="container">
    <div class="row">
      <div class="col-md-6 mb-4">
        <div class="contact-details">
          @if (showPhoneMain) {
            <h3><i class="bi bi-telephone-fill"></i> Phone</h3>
          }
          @if (showPhoneMain) {
            <p>{{CONTACT_US_PHONE_MAIN}}</p>
          }

          <h3><i class="bi bi-envelope-fill"></i> Email</h3>
          <p><a href="mailto:{{CONTACT_US_EMAIL_MAIN}}">{{CONTACT_US_EMAIL_MAIN}}</a></p>

          @if (showWhatsAppMain) {
            <h3><i class="bi bi-telephone-fill"></i> WhatsApp</h3>
          }
          @if (showWhatsAppMain) {
            <p>
              <a target="_blank"
                href="https://wa.me/{{CONTACT_US_WHATSAPP_MAIN}}?text=I'm%20contacting%20from%20nordnative%20website.%20I'm%20interested%20in%20your%20products.%20">
                {{CONTACT_US_PHONE_MAIN}}
              </a>
            </p>
          }
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <div class="working-hours">
          <div [innerHTML]="CONTACT_US_WORKING_HOURS"></div>
        </div>
      </div>

      @if (showMainAddress) {
        <div class="col-md-6 mb-4">
          <div class="contact-address">
            <h3><i class="bi bi-clock-fill"></i> Address</h3>
            <p>{{CONTACT_US_ADDRESS_MAIN}}</p>
          </div>
          @if (showMainAddressGoogleMap) {
            <div class="contact-address">
              <!-- This does not work because of some security reasons -->
              <!-- <iframe src="{{CONTACT_US_ADDRESS_MAIN_GOOGLE_MAP_URL}}" width="100%" height="450" style="border:0;"
            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2028.6413916955912!2d24.76389422721503!3d59.43905529534388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469293f4d919d3ad%3A0x8b1f5ca898a71b6d!2sAhtri%20tn%2012%2C%2013619%20Tallinn%2C%20Estland!5e0!3m2!1sde!2sde!4v1735847595999!5m2!1sde!2sde"
              width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        }
      </div>
    }
    @if (showMainAddress) {
      <div class="col-md-6 mb-4">
        <app-contactus-form></app-contactus-form>
      </div>
    }
  </div>
</div>
</section>


<div class="col-xs-12" style="height:200px;"></div>
